import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserManagementService } from '../../service/user-management.service';
import { NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.css']
})
export class UpdateUserComponent implements OnInit {
  roleDDL: any = [];
  selecteRole: string;
  result: any = [];
  customerMultiDDL: SelectItem[];
  selectedMultiDDL: number[] = [];
  customerSingleDDL: SelectItem[];
  selectedSingleDDL: number[] = [];
  user = {
    Id: '',
    UserName: '',
    PhoneNumber: '',
    FirstName: '',
    LastName: '',
    selecteRole: '',
    selectedDDL: [],
    OtpTypeId: null
  };
  message: string = '';
  msgs: Message[] = [];
  constructor(public route: ActivatedRoute, public dataService: UserManagementService, public router: Router) {
    this.dataService.getUser(this.route.snapshot.paramMap.get('id')).subscribe(result => {
      this.result = result;
      this.dataService.getRoleDDL().subscribe((res: any) => {
        this.roleDDL = res;
        this.selecteRole = this.result.Roles[0];
      });
    });
    this.dataService.getListCustomerDDL().subscribe((res: any) => {
      this.customerMultiDDL = res;
      this.customerSingleDDL = res;
    });

    this.dataService.getCustomerByUser(this.route.snapshot.paramMap.get('id')).subscribe((res: any) => {
      for (let i = 0; i < res.length; i++) {
        this.selectedMultiDDL.push(res[i].value);
      }
      //this.selectedSingleDDL = [res[0].value];
      this.selectedSingleDDL.push(res[0].value);

    });

  }

  ngOnInit() {
  }


  onSubmit(f: NgForm) {
    if (f.valid) {
      this.user.Id = this.route.snapshot.paramMap.get('id');
      this.user.UserName = f.value.UserName;
      this.user.PhoneNumber = f.value.PhoneNumber;
      this.user.FirstName = f.value.FirstName;
      this.user.LastName = f.value.LastName;
      this.user.OtpTypeId = f.value.OtpTypeId;
      this.user.selecteRole = f.value.selecteRole;
      if (f.value.selectedMultiDDL !== undefined) {
        this.user.selectedDDL = this.selectedMultiDDL;
      }
      else if (f.value.selectedSingleDDL !== undefined) {
        this.user.selectedDDL.push(this.selectedSingleDDL);
      }
      this.dataService.updateUser(this.user).subscribe(res => {
        this.message = res.toString();
        if (this.message === '0') {
          this.showSuccess();
          setTimeout(() => {
            this.router.navigate(['list-user']);
          }, 1500);
        }
        else if (this.message === '1') {
          this.showError();
        }
      }, (err: HttpErrorResponse) => {
          console.log(err);
          if (err && err.error && err.error.ExceptionMessage) {
            this.showMessage('error', '', err.error.ExceptionMessage);
          } else {
            this.showMessage('error', '', 'תקלה ביצירת משתמש חדש');
          }
        });
    }
  }
  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }
  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/user-management/update-user/update-user.component.ts